import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const sharePurchaseList = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.TICKET.SHARE_PURCHASE_LIST)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default sharePurchaseList;
